export default {
  data() {
    return {
      searchCityQuery: '',
    };
  },
  watch: {
    searchCityQuery(value) {
      let savedQuery = this.searchCityQuery;

      setTimeout(() => {
        if (this.searchCityQuery === savedQuery) {
          this.setCity(value);
          this.fetchTableData();
        }
      }, 1000);
    },
  },
};
